module.exports = __webpack_public_path__ + "img/arrow-return-left.f427cb55.svg";